export enum PlatformImageName {
    MenuLogo,
    DashboardBackground,
    ParticipantsAppHeader,
    ParticipantsAppSubHeader,
}